import {
  Button,
  HeadTitle,
  MenuBottomsheet,
  SelectField,
  Spacer,
  TextField,
  Tmd14,
} from 'oui';
import { SideBox, Height60, FloatingBox } from '../../etc/LBox/LBox';
import { useMtgTenant } from '../../../application/bloc/useMtgTenant';
import { useMtgConditions } from '../../../application/bloc/useMtgConditions';
import { currencyKR } from '../../../application/helper/filter';
import { ClkBtnSubEventNm } from '../../../application/hooks/useBeacon';

export const MtgTenant = () => {
  const {
    navigateNextStep,
    selectSheet,
    openSelectSheet,
    mortgageInfo,
    onChangeWrappingInput,
    onChangeInput,
    saveInputInfoTemp,
  } = useMtgConditions();
  const { isActive, sendBeaconClkBtnOption, sendBeaconClkBtn } = useMtgTenant();

  const onClickButton = () => {
    sendBeaconClkBtn(ClkBtnSubEventNm.Next, {
      loan_amount: mortgageInfo.previousAmt ?? '',
      deposit: mortgageInfo.tenantAmt ?? '',
    });
    void saveInputInfoTemp();
    navigateNextStep('PUSH');
  };

  const onClickSelectField = (type: string) => {
    openSelectSheet(type);
  };

  const onChangeMenuBottomsheet = (e: any) => {
    onChangeWrappingInput({
      key: selectSheet.stateNm,
      text: e.text,
      value: e.value,
    });
    if (selectSheet.stateNm === 'previousYn') {
      if (e.value === 'N') onClickSelectField('Tenant20');
    }

    if (selectSheet.title) {
      sendBeaconClkBtnOption({
        btmsheet_name: selectSheet.title,
        option_name: e.text,
        before_option_name: mortgageInfo[selectSheet.stateNm]?.text ?? '',
      });
    }
  };

  const Space = () => (
    <>
      <Spacer size={'md'} />
    </>
  );

  return (
    <>
      <HeadTitle
        textTitle={'해당 주택으로 받은 대출금과 세입자\n 정보를 입력해주세요'}
      />
      <Spacer size={'xs'} />
      <SideBox>
        <SelectField
          inputTitle="대출 여부"
          value={mortgageInfo.previousYn.text}
          placeholder={'대출 여부'}
          onChangeSelectField={() => {}}
          onClickSelectField={() => onClickSelectField('Tenant10')}
        />
        {mortgageInfo.previousYn.value === 'Y' && (
          <>
            <Space />
            <TextField
              inputTitle="보유 중인 대출 금액"
              placeholder={'0'}
              state={'enabled'}
              adornment={'만 원'}
              value={mortgageInfo.previousAmt ?? ''}
              inputMode={'numeric'}
              helperText={currencyKR(mortgageInfo?.previousAmt * 10000)}
              onChangeTextInput={(value) => {
                const amt = value.replace(/,/g, '');
                if (amt.length > 6) return;
                onChangeInput({ key: 'previousAmt', value });
              }}
            />
          </>
        )}
        {mortgageInfo.previousYn.value && (
          <>
            <Space />
            <SelectField
              inputTitle="세입자 유무"
              value={mortgageInfo.tenantYn.text}
              placeholder={'세입자 유무'}
              onChangeSelectField={() => {}}
              onClickSelectField={() => onClickSelectField('Tenant20')}
            />
          </>
        )}
        {mortgageInfo.tenantYn.value === 'Y' && (
          <>
            <Space />
            <TextField
              inputTitle="세입자 보증금"
              placeholder={'0'}
              state={'enabled'}
              adornment={'만 원'}
              value={mortgageInfo.tenantAmt ?? ''}
              inputMode={'numeric'}
              helperText={currencyKR(mortgageInfo?.tenantAmt * 10000)}
              onChangeTextInput={(value) => {
                const amt = value.replace(/,/g, '');
                if (amt.length > 6) return;
                onChangeInput({ key: 'tenantAmt', value });
              }}
            />
          </>
        )}
      </SideBox>
      <Height60 />
      <Spacer size="xs" />
      <FloatingBox>
        <Button
          flexible={true}
          configuration={'contained'}
          isDisabled={!isActive}
          state={isActive ? 'enabled' : 'disabled'}
          children={'다음'}
          onClick={onClickButton}
        />
      </FloatingBox>
      <MenuBottomsheet
        selectType="instant"
        isOpenBottomSheet={selectSheet.open}
        title={selectSheet.title}
        subTitle={selectSheet.subTitle}
        items={selectSheet.items}
        onClickMenuItem={(e: any) => {
          selectSheet.onClose();
          onChangeMenuBottomsheet(e);
        }}
        onClickCloseMenuBottomsheet={selectSheet.onClose}
        defaultValue={mortgageInfo[selectSheet.stateNm]}
      />
    </>
  );
};
